<template>
  <span class="relative inline-flex shrink-0 items-center justify-center rounded-lg border p-0.5 text-gray-300"
    :class="sizeClass" :style="frameStyle">
    <span class="flex size-full items-center justify-center overflow-hidden rounded-md">
      <slot />
    </span>
    <AppStatusBadge v-if="showStatusDot" variant="dot" :size="statusDotSize" :status="status"
      class="pointer-events-none absolute" :class="dotPositionClass" />
  </span>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'sm',
    },
    showStatusDot: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: 'unknown',
    },
  },
  computed: {
    sizeClass() {
      if (this.size === 'lg') {
        return 'size-12'
      }

      if (this.size === 'md') {
        return 'size-10'
      }

      return 'size-8'
    },
    dotPositionClass() {
      if (this.size === 'lg') {
        return '-bottom-1.5 -right-1.5'
      }

      if (this.size === 'md') {
        return '-bottom-2 -right-2'
      }

      return '-bottom-1.5 -right-1.5'
    },
    statusDotSize() {
      if (this.size === 'lg') {
        return 'lg'
      }

      if (this.size === 'md') {
        return 'md'
      }

      return 'sm'
    },
    frameStyle() {
      return {
        backgroundColor: 'rgba(var(--team-color-rgb, 125, 95, 255), 0.14)',
        borderColor: 'rgba(var(--team-color-rgb, 125, 95, 255), 0.28)',
      }
    },
  },
}
</script>
